<kuv-alert></kuv-alert>
<kuv-loading></kuv-loading>

<div class="container-fluid p-5">
    <h3>Ventas</h3>
    <button class="btn btn-primary my-2" (click)="add()"><i class="fas fa-plus-circle me-2"></i>Registrar Nueva Venta</button>

    <kuv-lazy-table url={{url}} urlExcel={{excel}} [headers]="sesion.headers" [headersBlob]="sesion.headersBlob"
        [pageSize]="20" [reloadEmitter]="reloadEmitter" [filtros]="filtros" [columnas]="columnas" [acciones]="acciones"
        [useIndex]="true" [isRounded]="true" [hasShadow]="true"></kuv-lazy-table>
</div>